export class User {
  constructor(
    readonly name: string,
    readonly email: string | null,
    readonly phoneNumber: string | null,
    readonly role: 'manager' | 'employee',
  ) {}
}
